import { FC } from "react";
import { Box } from "@mui/material";
import { NavLink } from "react-router-dom";
import img from "../../../Images/Main/DesktopVersion/tehnology_green_future.jpg";
import img_mob from "../../../Images/Main/MobileVersion/tehnology_green_future_mob.jpg";

const TechnologyGreenFuture: FC = () => {
  return (
    // <NavLink to="AboutUs">
      <Box
        sx={{
          width: "100%",
          height: { xs: "100vw", md: "35vw" },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          // cursor: "pointer",
          backgroundImage: { xs: `url(${img_mob})`, md: `url(${img})` },
          backgroundSize: "cover",
          backgroundPosition: "center center",
        }}
      ></Box>
    // </NavLink>
  );
};

export default TechnologyGreenFuture;
